import {Component, OnInit} from '@angular/core';
import {OfferService} from 'src/app/_services/offer.service';
import {IPagination} from 'src/app/_models/pagination';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {environment} from '../../../environments/environment';
import {UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import {ProductCategory} from 'src/app/_models/product-category';
import {combineLatest} from 'rxjs';
import {ProductCategoryService} from 'src/app/_services/product-category.service';
import {OfferStatus} from '../../commons/offer-status';

@Component({
    selector: 'app-offer',
    templateUrl: './offer.component.html',
    styleUrls: ['./offer.component.css'],
    standalone: false
})
export class OfferComponent implements OnInit {

    page = '1';
    offers: any[] = [];
    config: any;
    loading = true;
    filterCategoryId = '0';
    filterPrice = '0';
    productName = '';
    nameSort = '';
    createdAtSort = '';
    filterForm: UntypedFormGroup;
    categories: ProductCategory[];

    constructor(private offerService: OfferService,
                private router: Router,
                private route: ActivatedRoute,
                private fb: UntypedFormBuilder,
                private productCatService: ProductCategoryService,
                private browserTitle: Title) {
        // set browser title
        this.browserTitle.setTitle('Offers - ' + environment.appTitle);
        this.filterForm = this.fb.group({
            filterCategoryId: [0, Validators.pattern('^[0-9]+$')],
            filterPrice: ['', Validators.pattern('^[0-9]+$')],
            productName: ['', Validators.maxLength(50)]
        });
    }

    ngOnInit() {
        this.route.queryParamMap.subscribe(
            (paramAsMap: any) => {
                if (paramAsMap.params.page) {
                    this.page = paramAsMap.params.page;
                    this.nameSort = paramAsMap.params.name;
                    this.createdAtSort = paramAsMap.params.createdAt;
                }
            }
        );

        combineLatest(
            [
                this.productCatService.get_product_categories(),
                this.loadOfferByAdmin()
            ]
        ).subscribe(
            ([categories, values]) => {
                this.categories = categories;
                this.extractResult(values);
            },
            (error) => {},
            () => this.loading = false
        );

    }

    getOffers() {
        this.loading = true;
        this.loadOfferByAdmin().subscribe(
            (result: IPagination) => this.extractResult(result),
            null,
            () => this.loading = false
        );
    }

    getStatus(status) {
        return OfferStatus.getStatus(status);
    }

    extractResult(result: any) {
        this.offers = result.data;
        this.config = {
            currentPage: result.page,
            itemsPerPage: 30,
            totalItems: result.totalOfItems,
            id: 'pagination'
        };
    }

    loadOfferByAdmin() {
        return this.offerService.loadOffersByAdmin(Number(this.page), Number(this.filterCategoryId), Number(this.filterPrice), this.nameSort, this.createdAtSort, this.productName);
    }

    pageChange(page) {
        this.page = page;
        this.router.navigate(['/admin/offers'], {
            queryParams:
                {
                    page: this.page, perPage:
                    this.config.itemsPerPage,
                    name: this.nameSort,
                    createdAt: this.createdAtSort,
                    filterCategoryId: this.filterCategoryId,
                    filterPrice: this.filterPrice,
                    productName: this.productName
                }
        });
        this.getOffers();
    }

    sortResult(nameSort?: string, createdAtSort?: string, by?: string) {

        if(by === 'name') {
            this.nameSort = nameSort === 'desc' ? 'asc' : 'desc';
        } else {
            this.nameSort = '';
        }

        if(by === 'createdAt') {
            this.createdAtSort = createdAtSort === 'desc' ? 'asc' : 'desc';
        } else {
            this.createdAtSort = '';
        }

        this.router.navigate(['/admin/offers'], {
            queryParams:
                {
                    page: this.page, perPage:
                    this.config.itemsPerPage,
                    name: this.nameSort,
                    createdAt: this.createdAtSort,
                    filterCategoryId: this.filterCategoryId,
                    filterPrice: this.filterPrice,
                    productName: this.productName
                }
            });
        this.getOffers();
    }

    filterOffers() {
        if (this.filterForm.value.filterCategoryId === '' && this.filterForm.value.filterPrice === '') {
            return;
        }
        this.filterCategoryId = this.filterForm.value.filterCategoryId;
        this.filterPrice = this.filterForm.value.filterPrice;
        this.productName = this.filterForm.value.productName;
        if (this.filterForm.value.filterPrice === '' || this.filterForm.value.filterPrice === null) {
            this.filterPrice = '0';
        }

        this.getOffers();
    }

}
